<template>
  <v-app-bar
    elevation="0"
    dense
    app
    dark
    color="#5FAE91"
    clipped-left
    class="d-print-none"
  >
    <v-app-bar-nav-icon @click="changeDrawer" />
    <v-toolbar-title>.:: BRAIN BOX ::.</v-toolbar-title>
    <v-spacer />

    <v-chip v-show="loadSettings" color="primary">
      <v-progress-circular
        size="16"
        width="2"
        indeterminate
        class="mr-1"
      ></v-progress-circular>
      Loading...</v-chip
    >

    <v-menu offset-y :close-on-content-click="false" nudge-width="200">
      <template v-slot:activator="{ on, attrs }">
        <v-avatar color="primary" size="40" v-bind="attrs" v-on="on">
          <v-img
            :lazy-src="user.thumb_avatar ? user.thumb_avatar : photoEmpty"
            :src="user.avatar ? user.avatar : photoEmpty"
          />
        </v-avatar>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-img
                :lazy-src="user.thumb_avatar ? user.thumb_avatar : photoEmpty"
                :src="user.avatar ? user.avatar : photoEmpty"
              />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ user.full_name }}</v-list-item-title>
              <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-list-item to="/profile">
            <v-list-item-content>
              <v-list-item-title>Mi perfil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-content>
              <v-list-item-title>Cerrar sesion</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script>
import bus from "../../events/bus";
import photoEmpty from "../../assets/profile.jpeg";

export default {
  data() {
    return {
      loadSettings: false,
      photoEmpty: photoEmpty,
      dialogBusiness: false,
      loadingBusiness: false,
    };
  },

  beforeCreate() {
    bus.$on("loadSettings", (value) => {
      this.loadSettings = value;
    });
  },

  computed: {
    user() {
      return this.$store.getters.getUser;
    },

    business() {
      return this.$store.getters.getBusinessSelect;
    },

    businessSelected() {
      return this.$store.getters.getBusinessSelected;
    },
  },

  methods: {
    changeDrawer: () => {
      bus.$emit("changeDrawer");
    },

    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    },
  },
};
</script>

<style></style>
